<!-- Slide-over Mes listes de contrôle — Variation A (wilout/issues#4956) -->
<div class="varA" (click)="close()">

    <!-- Top bar -->
    <div class="varA-topbar" (click)="$event.stopPropagation()">
      <div class="varA-topbar-title">
        <span>Mes listes de contrôle :</span>
        <div class="varA-ss" [class.is-open]="statusMenuOpen" (mouseleave)="statusMenuOpen = false">
          <button type="button" class="varA-ss-trigger" (click)="statusMenuOpen = !statusMenuOpen">
            <span>{{ statusLabel }}</span>
            <i class="fa-solid fa-chevron-down"></i>
          </button>
          <div class="varA-ss-menu" *ngIf="statusMenuOpen">
            <button type="button" class="varA-ss-opt" *ngFor="let opt of statusOptions"
                    [class.is-active]="statusFilter === opt.value" (click)="setStatus(opt.value)">
              <i class="fa-solid fa-check"></i>
              <span>{{ opt.label }}<ng-container *ngIf="optionCount(opt.value)"> ({{ optionCount(opt.value) }})</ng-container></span>
            </button>
          </div>
        </div>
      </div>
      <div class="varA-topbar-right">
        <button type="button" class="varA-affichage" [class.is-grid]="viewMode === 'grid'" (click)="toggleView()"
                [title]="viewMode === 'list' ? 'Affichage grille' : 'Affichage liste'">
          <i class="fa-solid" [class.fa-bars]="viewMode === 'list'" [class.fa-grip]="viewMode === 'grid'"></i>
          <span>Affichage</span>
        </button>
        <button type="button" class="varA-close" aria-label="Fermer" (click)="close()"><i class="fa-solid fa-xmark"></i></button>
      </div>
    </div>

    <!-- Body -->
    <div class="varA-body">
      <div class="varA-panel" (click)="$event.stopPropagation()">

        <!-- Search + date -->
        <div class="varA-searchrow">
          <div class="varA-search">
            <i class="fa-solid fa-magnifying-glass"></i>
            <input type="text" [(ngModel)]="query" placeholder="Rechercher par nom ou ID…" />
            <button *ngIf="query" type="button" class="varA-search-clear" (click)="clearQuery()" aria-label="Effacer"><i class="fa-solid fa-xmark"></i></button>
          </div>
          <div class="varA-date-wrap">
            <button type="button" class="varA-date-iconbtn" [class.is-active]="datePreset"
                    (click)="dateFilterOpen = !dateFilterOpen" aria-label="Filtrer par date">
              <i class="fa-regular fa-calendar"></i>
              <span *ngIf="datePreset" class="varA-date-iconbtn-dot"></span>
            </button>
            <div class="varA-date-popover" *ngIf="dateFilterOpen">
              <div class="varA-date-presets">
                <button type="button" class="varA-date-preset" [class.is-active]="datePreset === '7j'" (click)="setDatePreset('7j')">7 derniers jours</button>
                <button type="button" class="varA-date-preset" [class.is-active]="datePreset === '30j'" (click)="setDatePreset('30j')">30 derniers jours</button>
                <button type="button" class="varA-date-preset" [class.is-active]="datePreset === 'mois'" (click)="setDatePreset('mois')">Ce mois</button>
                <button type="button" class="varA-date-preset" [class.is-active]="datePreset === 'annee'" (click)="setDatePreset('annee')">Cette année</button>
              </div>
              <div class="varA-date-divider">ou plage personnalisée</div>
              <div class="varA-date-range">
                <label><span>Du</span><input type="date" [ngModel]="dateFrom" (ngModelChange)="onDateFromChange($event)" /></label>
                <label><span>Au</span><input type="date" [ngModel]="dateTo" (ngModelChange)="onDateToChange($event)" /></label>
              </div>
              <div class="varA-date-actions">
                <button type="button" class="varA-date-clear" (click)="clearDate()">Réinitialiser</button>
                <button type="button" class="varA-date-apply" (click)="dateFilterOpen = false">Appliquer</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Count -->
        <div class="varA-countrow">
          <div class="varA-count">
            {{ items.length }} liste{{ items.length > 1 ? 's' : '' }}
            <span *ngIf="activeFiltersCount > 0" class="varA-count-pill">{{ activeFiltersCount }}</span>
          </div>
        </div>

        <!-- List -->
        <div class="varA-list" [class.is-grid]="viewMode === 'grid'" (dragend)="onDragEnd()">

          <div class="varA-empty" *ngIf="!loading && items.length === 0">
            <i class="fa-regular fa-folder-open"></i>
            <div>Aucune liste ne correspond</div>
            <button type="button" class="varA-empty-reset" (click)="resetFilters()">Réinitialiser les filtres</button>
          </div>

          <ng-container *ngIf="grouped; else flatList">
            <ng-container *ngFor="let item of activeItems; trackBy: trackById">
              <ng-container *ngTemplateOutlet="cardTpl; context: { $implicit: item }"></ng-container>
            </ng-container>

            <button type="button" *ngIf="expiredItems.length > 0" class="varA-expired-sep"
                    [class.is-open]="expiredOpen || searchActive" (click)="expiredOpen = !expiredOpen" [attr.aria-expanded]="expiredOpen || searchActive">
              <i class="fa-regular fa-clock"></i>
              <span>Listes expirées</span>
              <div class="varA-expired-count">{{ expiredItems.length }}</div>
              <i class="fa-solid fa-chevron-down varA-expired-chev"></i>
            </button>

            <ng-container *ngIf="expiredOpen || searchActive">
              <ng-container *ngFor="let item of expiredItems; trackBy: trackById">
                <ng-container *ngTemplateOutlet="cardTpl; context: { $implicit: item }"></ng-container>
              </ng-container>
            </ng-container>
          </ng-container>

          <ng-template #flatList>
            <ng-container *ngFor="let item of items; trackBy: trackById">
              <ng-container *ngTemplateOutlet="cardTpl; context: { $implicit: item }"></ng-container>
            </ng-container>
          </ng-template>
        </div>
      </div>
    </div>

</div>

<!-- Carte liste -->
<ng-template #cardTpl let-item>
  <div class="varA-card"
       [class.is-selected]="selectedId === item.id"
       [class.is-expired]="item.status === 'expired'"
       [class.is-dragging]="draggingId === item.id"
       [class.is-over]="overId === item.id"
       [class.is-archived]="item.archived"
       draggable="true"
       (dragstart)="onDragStart(item)"
       (dragover)="onDragOver(item, $event)"
       (drop)="onDrop(item)"
       (click)="select(item)">

    <div class="varA-card-handle" aria-label="Réorganiser" (click)="$event.stopPropagation()">
      <i class="fa-solid fa-grip-vertical"></i>
    </div>

    <div class="varA-card-main">
      <div class="varA-card-title-row">
        <div class="varA-card-title" [title]="item.name">{{ item.name }}</div>
        <span *ngIf="item.isDefault" class="varA-badge-default"><i class="fa-solid fa-star"></i> Par défaut</span>
        <span *ngIf="item.flag" class="varA-badge-flag"><i class="fa-solid fa-flag"></i> Marquée</span>
        <span *ngIf="item.archived" class="varA-badge-archived"><i class="fa-solid fa-box-archive"></i> Archivée</span>
        <span *ngIf="duplicateErrorId === item.id" class="varA-badge-error" role="alert" [attr.data-testid]="'list-duplicate-error-' + item.id"><i class="fa-solid fa-triangle-exclamation"></i> Copie impossible</span>
        <button type="button" class="varA-id-chip" (click)="copyId(item, $event)" [title]="'Copier l\'ID — ' + item.id">
          <span>ID</span>
          <i class="fa-regular" [class.fa-circle-check]="copiedId === item.id" [class.fa-copy]="copiedId !== item.id"></i>
        </button>
      </div>
    </div>

    <div class="varA-card-meta">
      <div class="varA-card-tarifs">
        <div class="varA-tarifs-num">{{ item.tarifs }}</div>
        <div class="varA-tarifs-lbl">tarif{{ item.tarifs > 1 ? 's' : '' }}</div>
      </div>
      <div class="varA-card-actions" (click)="$event.stopPropagation()">
        <button type="button" class="varA-action" [class.is-active]="item.hidden" (click)="toggleHidden(item, $event)" [title]="item.hidden ? 'Afficher' : 'Masquer'">
          <i class="fa-solid" [class.fa-eye]="item.hidden" [class.fa-eye-slash]="!item.hidden"></i>
        </button>
        <button type="button" class="varA-action" [class.is-active]="item.flag" (click)="toggleFlag(item, $event)" [title]="item.flag ? 'Retirer le marquage' : 'Marquer'">
          <i [class.fa-solid]="item.flag" [class.fa-regular]="!item.flag" class="fa-flag"></i>
        </button>
        <button type="button" class="varA-action" [class.is-active]="item.archived" (click)="toggleArchive(item, $event)" [title]="item.archived ? 'Désarchiver' : 'Archiver'">
          <i class="fa-solid fa-box-archive"></i>
        </button>
        <button type="button" class="varA-action" (click)="duplicate(item, $event)" title="Dupliquer"
                [attr.data-testid]="'list-duplicate-' + item.id"
                [disabled]="duplicatingId !== null" [attr.aria-busy]="duplicatingId === item.id">
          <i class="fa-regular fa-clone"></i>
        </button>
      </div>
    </div>
  </div>
</ng-template>
